import { TemplateId } from '../../../types/common';
/**
 * Returns true if header template used is partner template
 */
export var isPartnerHeaderTemplate = function (globalComponentsContext) { var _a; return !(((_a = globalComponentsContext === null || globalComponentsContext === void 0 ? void 0 : globalComponentsContext.header) === null || _a === void 0 ? void 0 : _a.templateId) === TemplateId.BEXHeader.valueOf()); };
//# sourceMappingURL=partner-utils.js.map